import * as Tone from 'tone'
import * as Tonal from 'tonal'
import { featuresContext } from '../features'
import { random_bool, shuffleArray } from '../../common/utils'

const { sacred, octave, baseHue, seed } = featuresContext;

const baseFreq = Tone.Frequency(baseHue).toNote().charAt(0)
const baseNote = `${baseFreq}${octave}`

let notes = [baseNote];
for (let o = octave; o < octave + 9; o++) {
  const scale = Tonal.Scale.notes(`${baseNote.charAt(0)} major`);
  if (!sacred) {
    shuffleArray(scale, seed);
  }
  scale.forEach((note) => {
    if (random_bool(0.5)) {
      notes.push(`${note}${o}`);
    }
    if (random_bool(0.1)) {
      notes.push(null);
    }
  });
}

const shuffledNotes = shuffleArray(notes, seed);


export const synth = new Tone.PolySynth(
  {
    envelope: {
      attack: 0.99,
      decay: 0.1,
      sustain: 0.2,
      release: 0.99,
    },
  },
  {
    volume: -25,
    fadeIn: 3,
    fadeOut: 3,
    oscillator: {
      type: "sine",
    },
  }
);
const autoPanner = new Tone.AutoPanner({
  frequency: "1m",
  depth: 1,
  wet: 0.7,
})
const synthFilter = new Tone.Filter(octave * 600, "lowpass");
const synthChorus = new Tone.Chorus(2, 4, 0.7);
const synthDelay = new Tone.FeedbackDelay(0.2, 0.7);
const synthReverb = new Tone.Reverb({
  decay: 10,
  wet: 0.3,
  preDelay: 0.3,
});
const synthLFO = new Tone.LFO(6, 0, 1)
synthLFO.connect(synthReverb.wet);
synth.chain(
  synthFilter,
  synthDelay,
  synthReverb,
  synthChorus,
  autoPanner,
  Tone.Destination
);

const synthSeq = new Tone.Sequence(
  (time, note) => {
    synth.triggerAttackRelease(note, sacred ? "128n" : "64n", time)
  },
  shuffledNotes,
  '32n',
  { humanize: 1 }
)

export const startSynth = () => {
  autoPanner.start()
  synthLFO.start()
  synthSeq.start()
}
